module.exports = __webpack_public_path__ + "static/Print pattern XS-02_logobase_3000-01-7958ec904e2bb4d6cbc132912ef492fa.png";